import { t } from '@alluzo/shared';
import { Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { Button } from '~/components/ui/button';

export function NotFound(): ReactElement {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 bg-background p-6 text-center">
      <h1 className="type-h3">{t('route.not_found.title')}</h1>
      <p className="max-w-[380px] text-base text-muted-foreground">{t('route.not_found.body')}</p>
      <Button asChild variant="outline">
        <Link to="/">{t('home.records')}</Link>
      </Button>
    </div>
  );
}
